export default __webpack_public_path__ + "static/media/img1.d635e691.jpg";